import axios from 'axios';

// Configuración base de Axios
const api = axios.create({
    baseURL: 'https://dymesenergy.gst-panel.com', // Tu URL base
    timeout: 10000, // Tiempo máximo de espera
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Interceptores para manejar errores globalmente
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Puedes manejar errores globales aquí
        return Promise.reject(error);
    }
);

export default api;